import type { Exercise } from '@heraion/shared';

import type { PlateLoadShape } from './plateConfigCore';

/** The load shape of an exercise: the one the athlete SAVED for it, else the
 *  catalog's (`barLoading`; absent reads as standard downstream). Only the
 *  precedence lives here; each caller does its own (async) read of the store. */
export const resolveLoadShape = (
  stored: PlateLoadShape | null | undefined,
  barLoading: Exercise['barLoading'],
): Exercise['barLoading'] | PlateLoadShape => stored ?? barLoading;
